import Carousel from 'react-bootstrap/Carousel';
 import slide1 from '../../assets/img/slides/AFRICANMOVIES.png'
 import slide2 from '../../assets/img/slides/FRANCOPHONE.png'
 import slide3 from '../../assets/img/slides/HEALTHY LIVING.png'
  import slide4 from '../../assets/img/slides/STRAIGHT TALK AFRICA.png'
 import slide5 from '../../assets/img/slides/fizzi.png'
 import slide6 from '../../assets/img/slides/konnenkt.png'
  import slide7 from '../../assets/img/slides/wildlife.png'
 import slide8 from '../../assets/img/slides/living word.png'
 import slide9 from '../../assets/img/banner3.png'
import './slider.css'
import slide10 from '../../assets/img/banner.png'
import { Container } from 'react-bootstrap';

function Slider(props) {

 
  return (

<Container fluid={true}>
<div class="row-fluid">
    <Carousel data-bs-theme="dark">
    <Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide1}
        alt="First slide"
      />
      <Carousel.Caption>
        {/* <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
      </Carousel.Caption>
    </Carousel.Item>


 <Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide2}
        alt="First slide"
      />
      <Carousel.Caption>
        {/* <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
      </Carousel.Caption>
    </Carousel.Item>
    <Carousel.Item>


       <Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide3}
        alt="First slide"
      />
      <Carousel.Caption>
        {/* <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
      </Carousel.Caption>
    </Carousel.Item>

     <Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide4}
        alt="First slide"
      />
      <Carousel.Caption>
        {/* <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
      </Carousel.Caption>
    </Carousel.Item>

     <Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide5}
        alt="First slide"
      />
      <Carousel.Caption>
        {/* <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
      </Carousel.Caption>
    </Carousel.Item>


     <Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide6}
        alt="First slide"
      />
      <Carousel.Caption>
        {/* <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
      </Carousel.Caption>
    </Carousel.Item>

     <Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide7}
        alt="First slide"
      />
      <Carousel.Caption>
        {/* <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
      </Carousel.Caption>
    </Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide8}
        alt="First slide"
      />
      <Carousel.Caption>
        {/* <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
      </Carousel.Caption>
    </Carousel.Item>


    
    <Carousel.Item>
      <img
        className="d-block img-fluid"
        src={slide4}
        alt="Second slide"
      />
      <Carousel.Caption>
        {/* <h5>Second slide label</h5>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
      </Carousel.Caption>
    </Carousel.Item>
    
  </Carousel>
  </div>
  </Container>
  );
}

export default Slider;